import type { Update } from '@ngrx/entity';
import type { TabEntity, GridEntity } from '@sites/entity-core';
import type {
    NormalizedBlockEntity,
    NormalizedColumnEntity,
    WebLegacyWidgetEntity,
    NormalizedSpecificSectionEntity,
} from '@web/types';
import type { BatchEntry, HistoryChange } from './history.model';

import { createActionGroup, props, emptyProps } from '@ngrx/store';

const HistoryActions = createActionGroup({
    source: 'History',
    events: {
        'Reset history': emptyProps(),
        'Add change to history': props<{ change: HistoryChange }>(),
        'Add block update change to history': props<{
            before: Update<NormalizedBlockEntity>;
            after: Update<NormalizedBlockEntity>;
        }>(),
        'Add columns update change to history': props<{
            before: Update<NormalizedColumnEntity>[];
            after: Update<NormalizedColumnEntity>[];
        }>(),
        'Add grids update change to history': props<{
            before: Update<GridEntity>[];
            after: Update<GridEntity>[];
        }>(),
        'Add grid update change to history': props<{
            before: Update<GridEntity>;
            after: Update<GridEntity>;
        }>(),
        'Add tab update change to history': props<{ before: Update<TabEntity>; after: Update<TabEntity> }>(),
        'Add widget update change to history': props<{
            before: Update<WebLegacyWidgetEntity>;
            after: Update<WebLegacyWidgetEntity>;
        }>(),
        'Add store update change to history': props<{ before: Update<any>; after: Update<any> }>(),
        'Add batch change to history': props<{ entry: BatchEntry }>(),
        'Undo request': emptyProps(),
        'Undo success': emptyProps(),
        'Redo request': emptyProps(),
        'Redo success': emptyProps(),
    },
});

export default HistoryActions;
